module.exports = __webpack_public_path__ + "img/coding_for_good_banner.5d617cc7.jpg";